import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import {
    calendarProviderAccountAdded,
    calendarProviderAccountsLoaded,
    calendarProviderAccountRemoved,
    calendarProviderAccountUnauthorized,
} from '../actions/publicActions';

mutator(calendarProviderAccountAdded, actionMessage => {
    const { providerAccount } = actionMessage;

    getStore().providerAccounts.push(providerAccount);
});

mutator(calendarProviderAccountsLoaded, actionMessage => {
    const { providerAccounts } = actionMessage;

    getStore().providerAccounts = providerAccounts || [];
});

mutator(calendarProviderAccountRemoved, actionMessage => {
    const store = getStore();
    const { calendarProviderAccountId } = actionMessage;

    store.providerAccounts = store.providerAccounts.filter(
        pa => pa.id !== calendarProviderAccountId
    );

    store.providerAccountUnauthorized.delete(calendarProviderAccountId);
});

mutator(calendarProviderAccountUnauthorized, actionMessage => {
    const store = getStore();
    const {
        providerAccount: { id },
    } = actionMessage;

    store.providerAccountUnauthorized.set(id, true);
});
